"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var PresetRow = /** @class */ (function (_super) {
    tslib_1.__extends(PresetRow, _super);
    function PresetRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSavePreset = function (e) {
            var _a = _this.props, onSave = _a.onSave, preset = _a.preset;
            onSave(preset);
        };
        _this.onDeletePreset = function (e) {
            var _a = _this.props, onDelete = _a.onDelete, preset = _a.preset;
            onDelete(preset);
        };
        _this.onPresetClick = function (e) {
            var _a = _this.props, onSelect = _a.onSelect, preset = _a.preset;
            onSelect(preset);
        };
        return _this;
    }
    PresetRow.prototype.render = function () {
        var preset = this.props.preset;
        return (React.createElement("li", { className: theme.preset },
            React.createElement("div", { className: "flex" },
                React.createElement(ui_1.LinkButton, { className: theme.linkButton, onClick: this.onPresetClick }, preset.name),
                preset.shared && React.createElement("span", { className: theme.shared }, "Shared")),
            React.createElement("div", { className: theme.links },
                React.createElement(ui_1.LinkButton, { onClick: this.onSavePreset, iconName: "icon-save", iconSize: 1.8 }),
                React.createElement(ui_1.LinkButton, { onClick: this.onDeletePreset, iconName: "icon-delete", iconSize: 1.8 }))));
    };
    PresetRow.defaultProps = {};
    return PresetRow;
}(React.Component));
exports.default = PresetRow;
